<template>
  <d-modal size="lg" @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('purchase.searchProductInOrders') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form v-if="!loadingInProgress && !resultsDisplay">
        <validation-observer ref="purchase-search-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('purchase.numberOfPiecesNeeded') }}:
            </label>

            <validation-provider
              rules="required|min_value:1"
              name="quantity"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="number"
                :min="1"
                :step="1"
                v-model="quantity" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>

      <div
        v-if="loadingInProgress"
        class="text-center">
        {{ $t('purchase.ordersSearchInProgress') }}&hellip;
      </div>

      <table
        v-if="!loadingInProgress && resultsDisplay && foundedPurchaseProducts.length"
        class="table">
        <thead>
          <th style="width: 65%;">{{ $t('product.product') }}</th>
          <th style="width: 35%;">{{ $t('purchase.bookIt') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="(purchaseProduct, index) of foundedPurchaseProducts"
            :key="'purchase-results-' + index">
            <td>
              {{ purchaseProduct.product_name }}<br>
              <template v-if="purchaseProduct.size_name"><small>{{ $t('purchase.size.size') }}: <span class="text-primary">{{ purchaseProduct.size_name }}</span></small><br></template>
              <template v-if="purchaseProduct.material_name"><small>{{ $t('purchase.fabric.fabric') }}: <span class="text-primary">{{ purchaseProduct.material_name }}</span></small><br></template>
              <template v-if="purchaseProduct.color_name"><small>{{ $t('purchase.fabric.fabricColor') }}: <span class="text-primary">{{ purchaseProduct.color_name }}</span></small><br></template>
              <template v-if="purchaseProduct.polar_name"><small>{{ $t('purchase.fleece.fleece') }}: <span class="text-primary">{{ purchaseProduct.polar_name }}</span></small><br></template>
              <template v-if="purchaseProduct.seam_name"><small>{{ $t('purchase.stitching.stitching') }}: <span class="text-primary">{{ purchaseProduct.seam_name }}</span></small></template>

              <p
                v-if="!isEditMode || !orderProductID"
                class="mt-0 mb-0">
                <small class="text-danger">
                  {{ $t('purchase.saveOrderToBookProducts') }}
                </small>
              </p>
            </td>

            <td>
              <d-button
                type="success"
                @click.prevent="makeReservation(purchaseProduct.id, purchaseProduct.quantity_available, purchaseProduct.purchase_id, purchaseProduct)"
                class="w-100 text-center pl-1 pr-1"
                :disabled="!isEditMode || !orderProductID">
                {{ $t('purchase.bookIt') }} {{ quantity > purchaseProduct.quantity_available ? purchaseProduct.quantity_available : quantity }} {{ $t('ui.piecesAbbr') }}
              </d-button>

              <p class="text-center mb-0">
                <small>
                  {{ $t('purchase.available') }}: <strong class="text-success">{{ purchaseProduct.quantity_available }} {{ $t('ui.piecesAbbr') }}</strong>
                </small>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="!loadingInProgress && resultsDisplay && !foundedPurchaseProducts.length"
        show>
        {{ $t('purchase.noOrdersWithSufficientProductQuantityFound') }}
      </d-alert>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        v-if="!loadingInProgress && !resultsDisplay"
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.search') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'purchase-search-popup',
  props: [
    'productID',
    'purchaseID',
    'orderProductID',
    'missingAmount'
  ],
  computed: {
    isEditMode () {
      return !!this.$route.params.id;
    }
  },
  data () {
    return {
      quantity: 1,
      foundedPurchaseProducts: [],
      loadingInProgress: false,
      resultsDisplay: false
    };
  },
  mounted () {
    this.quantity = this.missingAmount;

    if (this.quantity < 0) {
      this.quantity = 0;
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('purchase-search-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['purchase-search-form'], this.searchPurchase);
    },
    searchPurchase () {
      this.loadingInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/purchases/search-products',
        formData: {
          purchase_id: this.purchaseID,
          product_id: this.productID,
          order_product_id: this.orderProductID,
          quantity: parseInt(this.quantity, 10)
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.actionFailedTryAgain'),
        successAction: (response) => {
          this.foundedPurchaseProducts = response.data;
          this.loadingInProgress = false;
          this.resultsDisplay = true;
        },
        failAction: () => {
          this.loadingInProgress = false;
        }
      });
    },
    cancel () {
      this.foundedPurchaseProducts = [];
      this.resultsDisplay = false;
      this.quantity = 1;
      this.handleClose();
    },
    makeReservation (purchaseProductID, quantityAvailable, purchaseID, productData) {
      let qty = this.quantity;

      if (quantityAvailable < this.quantity) {
        qty = quantityAvailable;
      }

      this.$bus.$emit(
        'order-product-purchase-reservation',
        this.productID,
        this.orderProductID,
        purchaseProductID,
        purchaseID,
        parseInt(qty, 10),
        productData
      );
      this.cancel();
    }
  }
}
</script>
